import { ChatBotFlowError } from "@/protocols/chatBotFlow"

type FlowValidationContent = {
	errorMessage: string
}

type FlowValidationConfig = {
	[key in ChatBotFlowError]: FlowValidationContent
}

export const flowValidationConfig: FlowValidationConfig = {
	finish_attendance_block_not_find: {
		errorMessage: "Seu bot necessita do bloco de \"Finalizar atendimento\" para funcionar"
	},
	block_without_mandatory_connection: {
		errorMessage: "Conexões pendentes no bloco"
	},
	finish_flow_block_not_find: {
		errorMessage: "Seu bot necessita do bloco de \"Finalizar bot\" para funcionar"
	},
	block_missing_content: {
		errorMessage: "Bloco sem conteúdo"
	},
	multiple_condition_block_without_answer: {
		errorMessage: "Bloco sem resposta"
	},
	transfer_block_missing_selection: {
		errorMessage: "Bloco sem nenhuma transferência selecionada"
	},
	attendace_schedule_missing_time: {
		errorMessage: "Horário de atendimento não selecionado"
	},
	attendance_schedule_end_time_cannot_be_equal_or_lower_than_start_time: {
		errorMessage: "O horário de término não pode ser igual ou menor ao horário de início"
	},
	save_answer_block_missing_location: {
		errorMessage: "Local para salvar não selecionado"
	},
	manage_client_tags_block_missing_tag_selection: {
		errorMessage: "Tag não selecionada"
	},
	ai_manage_client_tags_block_missing_description: {
		errorMessage: "Bloco com tag selecionada sem descrição"
	},
	go_to_block_missing_bot: {
		errorMessage: "Bloco sem nenhum bot selecionado"
	},
	random_path_flow_missing_path: {
		errorMessage: "Bloco sem caminho selecionado"
	},
	optout_optin_missing_selection: {
		errorMessage: "Bloco sem opção selecionada"
	},
	webhook_block_missing_url: {
		errorMessage: "Bloco sem link inserido"
	},
	condition_block_missing_option: {
		errorMessage: "Bloco sem opção selecionada"
	},
	active_campaign_missing_tag: {
		errorMessage: "Bloco sem tag inserida"
	},
	active_campaign_block_missing_deal: {
		errorMessage: "Bloco sem funil de vendas e etapa adicionada"
	},
	active_campaign_not_connected: {
		errorMessage: "Active Campaign não está conectado"
	},
	meta_ads_event_conversion_missing: {
		errorMessage: "Bloco sem nenhum evento selecionado"
	},
	api_block_missing_url: {
		errorMessage: "Url não configurada"
	},
	api_block_custom_field: {
		errorMessage: "Campo personalizado não configurado"
	},
	missing_action_in_manager_contact_in_board: {
		errorMessage: "Bloco sem nenhuma ação selecionada"
	},
	missing_selected_board_in_manager_contact_in_board: {
		errorMessage: "Bloco sem nenhum funil selecionado"
	},
	missing_selected_stage_in_manager_contact_in_board: {
		errorMessage: "Bloco sem nenhuma etapa selecionada"
	},
	missing_condition_title_in_ai_condition_block: {
		errorMessage: "Bloco com alguma condição sem título configurado"
	},
	missing_condition_description_in_ai_condition_block: {
		errorMessage: "Bloco com alguma condição sem identificação configurada"
	},
	missing_condition_example_in_ai_condition_block: {
		errorMessage: "Bloco com alguma condição sem exemplo configurado"
	},
	missing_condition_title_in_ai_intention_block: {
		errorMessage: "Bloco com alguma intenção sem nome configurado"
	},
	missing_condition_description_in_ai_intention_block: {
		errorMessage: "Bloco com alguma intenção sem identificação configurada"
	},
	missing_condition_example_in_ai_intention_block: {
		errorMessage: "Bloco com alguma intenção sem exemplo configurado"
	},
	ai_agent_block_missing_agent: {
		errorMessage: "Bloco sem agente de ia selecionado"
	},
	ai_agent_api_block_custom_field: {
		errorMessage: "Bloco sem campo personalizado selecionado"
	},
	rd_station_crm_block_missing_deal: {
		errorMessage: "Bloco sem funil de vendas ou etapa adicionada"
	},
	ai_follow_up_block_missing_fallback_template: {
		errorMessage: "Bloco de follow-up com IA com tentativa sem template selecionado"
	},
	ai_follow_up_block_missing_attempt: {
		errorMessage: "Bloco de follow-up com IA sem tentativas configuradas"
	},
	wait_for_client_response_block_missing_variable_name: {
		errorMessage: "Nome da variável de resposta não definido"
	},
	superlogica_block_missing_association: {
		errorMessage: "Bloco sem nenhuma associação configurada"
	},
	superlogica_block_missing_condominium: {
		errorMessage: "O campo personalizado com o nome do condomínio não foi informado"
	},
	custom_field_fill_block_missing_field_selection: {
		errorMessage: "Selecione ao menos um campo personalizado antes de salvar."
	},
	custom_field_fill_block_missing_instruction: {
		errorMessage: "Bloco com campo personalizado sem instrução"
	}
}
